import { z } from 'zod'

export const customerClassificationSchema = z.object({
	name: z.string().trim().min(2, 'Name must have at least 2 characters'),
})
